// extracted by mini-css-extract-plugin
export default {"chat":"Chat_chat__Rxlar","close":"Chat_close__QbD+r"};